import wbTicketCountTemplate from './ticket_count.template.html';

angular.module('bl.basket').component('wbTicketCount', {
    controller: ['$scope', '$uibModal', WbTicketCountController],
    controllerAs: '$ticketCountCtrl',
    templateUrl: wbTicketCountTemplate.id,
    bindings: {
        basketItems: '<',
        continueText: '<'
    }
});

function WbTicketCountController($scope, $uibModal) {
    let self = this;
    this.$onChanges = function ({ basketItems }) {
        if (angular.isDefined(basketItems) && basketItems.currentValue) {
            // Filter out items with tickets
            let itemsWithTickets = basketItems.currentValue.filter(item => {
                return item.tickets;
            });

            self.ticketCount = 0;
            self.spacesCount = 0;
            itemsWithTickets.forEach(item => {
                self.ticketCount += item.tickets.qty;
                let countsAs = item.tickets.counts_as ? item.tickets.counts_as : 1;
                self.spacesCount += item.tickets.qty * countsAs;
            });
        }
    }
}


// WEBPACK FOOTER //
// src/public/javascripts/basket/ticket_count/basket.component.js